import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToasterService {
  private notifications = new Subject<{ type: string, message: string, id: number }>();
  private counter = 0;

  getNotifications(): Observable<{ type: string, message: string, id: number }> {
    return this.notifications.asObservable();
  }

  showNotification(type: string, message: string): void {
    this.notifications.next({ type, message, id: ++this.counter });
  }

  showSuccess(message: string): void {
    this.showNotification('success', message);
  }

  showError(message: string): void {
    this.showNotification('error', message);
  }

  showErrors(messages: string[]): void {
    messages.map((a) => {
      this.showNotification('error', a);
    })
  }

  showWarning(message: string): void {
    this.showNotification('warning', message);
  }

  showInfo(message: string): void {
    this.showNotification('info', message);
  }
}
